import { render, staticRenderFns } from "./TasksResults.vue?vue&type=template&id=320dec59"
import script from "./TasksResults.vue?vue&type=script&lang=js"
export * from "./TasksResults.vue?vue&type=script&lang=js"
import style0 from "./TasksResults.vue?vue&type=style&index=0&id=320dec59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports